import { createFeatureSelector, createSelector } from '@ngrx/store';
import { IMergeState } from './merge.state';

export const getMergeState = createFeatureSelector<IMergeState>('merge');

export const isBusy = createSelector(
  getMergeState,
  state => state.isBusy
);

export const canMerge = createSelector(
  getMergeState,
  state => state.canMerge
);

export const getResult = createSelector(
  getMergeState,
  state => state.result
);

export const getId = createSelector(
  getMergeState,
  state => state.id
);

export const getAdditionalId = createSelector(
  getMergeState,
  state => state.additionalId
);
